
export function evaluateQueryStringBooleanParameter( value) {
  return value !== null ? value === 'true' || value === '1' : true;
}

export function uniformDomain( srcDomain) {
  const lowerCaseSrcDomain = (srcDomain && srcDomain.toLowerCase && srcDomain.toLowerCase()) || '';
  const matchDomain = /^(https?:)?(\/\/)?(www\.)?([^/:]+)/.exec( lowerCaseSrcDomain);
  if( matchDomain && matchDomain[4]) return matchDomain[4];
  else return '';
}

export function uniqueMountScript( id, src) {
  if( !uniqueMountScript.cache) uniqueMountScript.cache = {};
  return new Promise( resolve => {
    if( id in uniqueMountScript.cache) resolve();
    else {
      uniqueMountScript.cache[id] = true;
      const script = document.createElement('script');
      script.id = id;
      script.src = src;
      script.onload = resolve;
      document.head.appendChild( script);
    }
  });
}

export function hashCode( str) {
  return `${str}`.split( '').reduce( (prevHash, currVal) => {
    return ((( prevHash << 5) - prevHash) + currVal.charCodeAt(0)) | 0;
  }, 0);
}

export function isIE11() {
  return (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0);
}

export function IE11_safeIncludes( searchable, target) {
  let ret = false;
  if( searchable) {
    if( searchable.includes) {
      ret = searchable.includes( target);
    } else if( searchable.indexOf) {
      ret = searchable.indexOf( target) !== -1;
    }
  }
  return ret;
}

export function IE11_safeFrameElement() {
  try {
    return window.frameElement;
  } catch( _) {};
  return null;
}

export function add_to_local_storage_counter( key) {
  const value = parseInt(`0${localStorage.getItem( key)}`) || 0;
  localStorage.setItem( key, value + 1);
}